import { jsx as o } from "react/jsx-runtime";
import { Placeholder as m } from "../Placeholder/Placeholder.js";
import { EmptyPlaceholderIcon as c } from "./EmptyPlaceholderIcon.js";
function n({ title: r, message: t, onRetry: e }) {
  return /* @__PURE__ */ o(
    m,
    {
      title: r,
      message: t,
      onRetry: e,
      Icon: /* @__PURE__ */ o(c, { width: 178 })
    }
  );
}
export {
  n as EmptyPlaceholder
};
//# sourceMappingURL=EmptyPlaceholder.js.map
